import type { DEVICES_TYPES_FOR_API } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

export type Color = `#${string}`;

export enum CreatingSteps {
    Initial,
    Name,
}

export type RTFormData = {
    competitors: string[];
    source: DEVICES_TYPES_FOR_API;
    country: number;
    name?: string;
    hasError?: boolean;
};

export enum RTWidgetNames {
    FirstPosition = "movedToTopKeywordsLastDate",
    Top10 = "movedTop10",
    Dropped = "droppedToSecondPage",
    MovedToTop3 = "movedTop3",
}

export type RTDefaultParams = {
    graphTab?: string;
    tableTab?: string;
    sortedColumn?: string;
    asc?: boolean;
    serpFilterGroup?: string;
    positionGroup?: string;
    sort?: string;
};
